import viewReducer from './view/viewReducer';
import dataReducer from './data/dataReducer';
import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import type { AppState } from '../state';

const reducer: Reducer<AppState> = combineReducers<AppState>({
    view: viewReducer,
    data: dataReducer,
} as ReducersMapObject<AppState>);

export default reducer;
